export const sfmcBody = Object.freeze({
    MID: '7234769',
    Butiksnr: '8004',
    b2b_debitor: 'B2C',
    SubAction: 'sub_add_update',
});
export const sfmcPostUrl = 'https://cl.s7.exct.net/subscribe.aspx?lid=169442';
export const domain = 'Lindberghfashion.com';
